<template>
  <tabs parent="ips">
    <tab id="list" :name="translate('addresses.ip-rules')" :href="url+'list'" >
      <IpsList />
    </tab>

    <tab id="history" :name="translate('addresses.history')" :href="url+'history'" >
      <IpsHistory />
    </tab>

  </tabs>
</template>

<script>

import {Tabs, Tab} from 'components/UIComponents/Tabs'
import IpsHistory from './Ips/IpsHistory.vue'
import IpsList from './Ips/IpsList.vue'

export default {
  name: 'Ips',
  components:{
    Tab,
    Tabs,
    IpsList,
    IpsHistory,
  },
  props: {
  },
  data () {
    return {
      load: true,
    }
  },
  computed: {
    url () { return '/ips/' }
  },

}
</script>
